var map = {
	"./img_1.jpg": 36977,
	"./img_2.jpg": 53434,
	"./img_3.jpg": 71031,
	"./img_4.jpg": 48095,
	"./img_5.jpg": 9980,
	"./img_6.jpg": 13315,
	"./img_7.jpg": 25288,
	"./img_8.jpg": 15901
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9873;